import api from './api';
import axios from 'axios';

export const whatsappAPI = {
  // Listar conversas
  listarConversas: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
        queryParams.append(key, params[key]);
      }
    });
    const queryString = queryParams.toString();
    return api.get(`/whatsapp/conversations${queryString ? `?${queryString}` : ''}`);
  },

  // Buscar mensagens de uma conversa
  buscarMensagens: (chatId, params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
        queryParams.append(key, params[key]);
      }
    });
    const queryString = queryParams.toString();
    return api.get(`/whatsapp/conversations/${chatId}/messages${queryString ? `?${queryString}` : ''}`);
  },

  // Enviar mensagem
  enviarMensagem: (dados) => {
    return api.post('/whatsapp/send-message', dados);
  },

  // Enviar mensagem de texto simples
  enviarTexto: (dados) => {
    return api.post('/whatsapp/send-text', dados);
  },

  // Verificar status da instância
  verificarStatus: () => {
    return api.get('/whatsapp/instance/status');
  },

  // Conectar instância
  conectarInstancia: () => {
    return api.post('/whatsapp/instance/connect');
  },

  // Desconectar instância
  desconectarInstancia: () => {
    return api.post('/whatsapp/instance/disconnect');
  },

  // Baixar áudio descriptografado
  baixarAudio: (messageData) => {
    return api.post('/whatsapp/download-audio', { messageData }, {
      responseType: 'blob'
    });
  },

  // Enviar lead para webhook externo
  enviarLeadParaWebhook: (dados) => {
    // Import axios here or use a raw instance to avoid default interceptors/baseURL
    // We need a fresh axios instance or just axios directly if imported
    // Since 'api' is the custom instance, we should use a clean axios call or fetch
    // Importing axios here locally or trusting the global/module availability if I modify the top of the file
    // Let's modify the top of the file to ensure axios is available, or just use fetch for simplicity/isolation
    // But axios is already used in the project. I'll stick to the plan: use axios directly.
    // However, I need to make sure axios is imported in the file.
    return axios.post('https://revendacarropadrao-n8n.r660at.easypanel.host/webhook/api/whatsapp/lead', dados, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic NTAyNThmNWE4ZTYwNzI3NDEwMGQzYjkyNTRmZGQ1YzQwNWE2ZTc4NTJhNjdjNDZkODc3YzBmOTBkODVhNzg1OToxNGI2Y2QxMDkwYjdlMGI5N2M1MzRmOTE0Yjc3MmNiYmI0Y2VmMjU2YTBlMGVjMmMxZGJlYWVkNGZhOTE1MDVl'
      }
    });
  }
};
